// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"227":"ef592ae3","351":"6c2254a7","591":"442e317d","850":"e0396cc7","856":"2f56154f","887":"e5eb1a40"}[chunkId] + ".chunk.css";
};